/**
 * ==========================================================
 * Password Rules
 *
 * Temporary constants.
 *
 * Later these values will come from
 * Password Policy API.
 * ==========================================================
 */

export const PASSWORD_RULES = {

    MIN_LENGTH: 8,

    MAX_LENGTH: 64,

    REQUIRE_UPPERCASE: true,

    REQUIRE_LOWERCASE: true,

    REQUIRE_NUMBER: true,

    REQUIRE_SPECIAL: true,

    PASSWORD_HISTORY: 5,

    PREVENT_DICTIONARY_WORDS: false,

    PASSWORD_EXPIRY_DAYS: 90

};